<template>
  <div class="bar">
    <div v-for="scale in scales" :key="scale" :class="`slot ${ scale_ranges_arranged.includes(scale) ? 'taken' : '' } ${ is_chosen(scale) ? 'chosen' : '' }`">
      <div v-if="scale % 2 === 0" class="time">{{scale === 0 ? init_time : parseInt(init_time) + (scale / 2)}}</div>
      <div v-if="scales.length - 1 === scale" class="time time-last">{{finish_time}}</div>
    </div>
  </div>
</template>

<script>
import {range, flattenDeep} from 'lodash';
import { getHours } from 'date-fns';
export default {
  props: ['init_time', 'finish_time', 'taken_orders', 'selected_start_time', 'selected_end_time'],
  data: function() {
    return {
      scales: range(0, (this.finish_time - this.init_time) * 2),
      times: range(this.init_time, this.finish_time),
    }
  },
  computed: {
    scale_ranges_arranged: function() {
      let results = this.taken_orders.map((order) => {
        return order.scale_ranges;
      });
      return flattenDeep(results);
    },
  },
  methods: {
    is_chosen(index) {
      return this.selected_end_time && this.selected_end_time >= this.selected_start_time[1] && range(this.selected_start_time[1], this.selected_end_time + 1).includes(index);
    }
  }
}
</script>

<style>
  .bar {
    width: 100%;
    height: 30px;
    display: flex;
    border: 1px solid grey;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .slot {
    flex: 1;
    position: relative;
    border-right: 1px solid grey;
  }
  .slot:last-child {
    border-right: none;
  }
  .slot.taken {
    background: #d0d0d0;
  }
  .slot.chosen {
    background: #63b6b8;
    border-right: 1px solid white;
  }
  .slot .time {
    position: absolute;
    top: 30px;
    left: -7px;
    font-size: 12px;
    color: #6f6f6f;
  }
  .slot:first-child .time {
    position: absolute;
    left: -2px;
  }
  .slot .time-last {
    left: 5px;
  }

</style>